export default function CTA() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-orange-50/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative rounded-3xl overflow-hidden shadow-2xl">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/624e93ae8a1cab02c9437460a65d7d32.jpg"
              alt="Professional HVAC Service"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
          </div>

          <div className="relative z-10 py-24 px-8 text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              Ready to restore your<br />
              <span className="font-light italic text-gray-200">comfort?</span><br />
              <span className="font-bold">We&apos;re here to help.</span>
            </h2>

            <p className="text-lg text-white/90 max-w-2xl mx-auto mb-10">
              Don&apos;t let HVAC issues disrupt your comfort. Our expert technicians are ready to provide fast, reliable service for all your heating and cooling needs.
            </p>

            <button
              onClick={scrollToContact}
              className="bg-white text-gray-900 px-12 py-4 rounded-full text-base font-semibold hover:bg-gray-100 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Schedule Your Service
            </button>

            <div className="mt-10 flex items-center justify-center space-x-8 text-white">
              <div className="flex items-center space-x-2">
                <i className="ri-time-line text-2xl"></i>
                <span className="text-sm font-medium">Same-Day Service</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-shield-check-line text-2xl"></i>
                <span className="text-sm font-medium">Licensed & Insured</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-star-fill text-2xl text-yellow-400"></i>
                <span className="text-sm font-medium">5.0 Rating</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
